import { useMemo } from 'react';
import { useAuthState } from '@vis-auth/react';
import { UserApi, Configuration } from '@vis-auth/vis-user-client';

const VIS_USER_URL = '/api/visuser';

const useConfiguration = (): Configuration => {
  const { accessToken } = useAuthState();

  const configuration = useMemo(
    () =>
      new Configuration({
        basePath: VIS_USER_URL,
        accessToken: accessToken ?? '',
      }),
    [accessToken],
  );

  return configuration;
};

const useUserApi = (): UserApi => {
  const configuration = useConfiguration();
  const api = useMemo(() => new UserApi(configuration), [configuration]);

  return api;
};

// Creates user api for provided access token
export const createUserApiWithToken = (accessToken: string): UserApi => {
  const configuration = new Configuration({
    basePath: VIS_USER_URL,
    accessToken,
  });
  const api = new UserApi(configuration);

  return api;
};

export default useUserApi;
